<template>
	<div class="progress" :style="{
		'--percentage': (percentageStart / percentageEnd * 100).toFixed(0) + '%',
		'--height': height
	}">
		<div class="progress_bg">
			<div class="progress_active">
				<div class="progress_text" v-if="isShow">{{ percentageStart }} / {{ percentageEnd }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		percentageStart: {
			type: Number,
			default: 0
		},
		percentageEnd: {
			type: Number,
			default: 0
		},
		height: {
			type: String,
			default: 'calc(10rem / 16)'
		},
		isShow: Boolean
	},
}
</script>

<style lang="less" scoped>
.progress {
	display: flex;
	@height: calc(20rem / 16);
	margin-right: calc(5rem / 16);

	.progress_bg {
		flex: 1;
		height: var(--height);
		border-radius: calc(50rem / 16);
		background-color: var(--gold);
		position: relative;
		// overflow: hidden;
		margin-top: calc(@height + 5px);

		.progress_text {
			height: @height;
			position: absolute;
			top: calc(@height * -1 - 5px);
			background-color: var(--light);
			color: var(--textColor);
			width: max-content;
			padding: 0 calc(5rem / 16);
			font-size: calc(12rem / 16);
			line-height: @height;
			border-radius: calc(4rem / 16);
			left: calc(var(--percentage) / 2);
		}

		.progress_active {
			position: absolute;
			left: 0;
			top: 0;
			height: var(--height);
			background-color: var(--light);
			width: var(--percentage);
			z-index: 1;
			border-radius: calc(50rem / 16);

			&::before {
				position: absolute;
				content: '';
				width: 0;
				height: 0;
				right: 0;
				top: -5px;
				border-left: 5px solid transparent;
				border-right: 5px solid transparent;
				border-top: 5px solid var(--light);
			}
		}
	}
}
</style>